import { brandPalette } from "../../../../constants/brandPalette";
import {
  Box,
  Button,
  Flex,
  Heading,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MainModel from "../../../../components/Models/main-model";
import { closeShowStudentDataModel } from "../../../../modules/admin-modules/models/Actions";

const ShowPassword = ({ data }) => {
  const openStudentData = useSelector((state) => state.model.isOpen9);
  const dispatch = useDispatch();

  const header = (
    <Box>
      <Heading
        fontSize="28px"
        fontWeight="800"
        color={brandPalette.primary}
        fontFamily="'Amiri','Tajawal',sans-serif"
        textAlign="center"
      >
        Student Data
      </Heading>
      <Text
        fontSize="xs"
        mt={1}
        color="rgba(69, 11, 17, 0.6)"
        textTransform="uppercase"
        letterSpacing="0.12em"
        fontWeight="700"
        textAlign="center"
      >
        Credentials for the new student
      </Text>
    </Box>
  );

  const closeFunc = () => {
    dispatch(closeShowStudentDataModel());
  };

  const fieldBlock = (label, value, { mono = false } = {}) => (
    <Box>
      <Text
        as="span"
        display="block"
        fontSize="14px"
        fontWeight="700"
        color={brandPalette.primary}
        mb={2}
        textAlign="left"
      >
        {label}
      </Text>
      <Box
        px={4}
        py={3}
        bg={brandPalette.cream}
        border={`1px solid ${brandPalette.stone}`}
        borderRadius="lg"
        fontSize="md"
        fontWeight="600"
        color={brandPalette.accentDark}
        fontFamily={mono ? "ui-monospace, monospace" : undefined}
        wordBreak="break-word"
      >
        {value != null && String(value).trim() !== "" ? value : "—"}
      </Box>
    </Box>
  );

  return (
    <MainModel
      header={header}
      closeFunc={closeFunc}
      openVar={openStudentData}
      buttonTitle={null}
      size="md"
      contentProps={{
        dir: "ltr",
        bg: brandPalette.warmBeige,
        borderRadius: "16px",
        overflow: "hidden",
        boxShadow: "2xl",
      }}
      headerProps={{
        px: 8,
        pt: 8,
        pb: 6,
        borderBottom: "1px solid rgba(216, 206, 195, 0.5)",
      }}
      bodyProps={{ px: 8, py: 8, pb: 6 }}
      hideDefaultFooter
    >
      <Stack spacing={8} dir="ltr" w="100%">
        <VStack align="stretch" spacing={5}>
          {fieldBlock("Student Name", data?.name)}
          {fieldBlock("Password", data?.password, { mono: true })}
        </VStack>
        <Flex justify="flex-end" pt={2}>
          <Button
            onClick={closeFunc}
            variant="ghost"
            color={brandPalette.accentDark}
            fontWeight="800"
            _hover={{ textDecoration: "underline" }}
          >
            Cancel
          </Button>
        </Flex>
      </Stack>
    </MainModel>
  );
};

export default ShowPassword;
